<div class="highlight">
  <div #horizontalBar class="chart"></div>
</div>